import React from 'react'

import { OperationRequestsTable } from './operation-requests-table.tsx'
import { OperationRequestsActions } from './components/operation-requests-actions.tsx'

export const OperationRequestsPage = (): React.ReactElement => {
  return (
    <>
      <OperationRequestsActions />
      <OperationRequestsTable />
    </>
  )
}
